import {Trans} from "../utils/i18n";
import timezones from "timezones-list";

export const userRegistrationSegway = {
    sizes: {
        forth: 3,
        third: 4,
        half: 6,
        full: 12,
    },
    heading: <Trans i18nKey={"auth.register"}>Register</Trans>,
    fields: [
        {
            name: "name",
            label: <Trans i18nKey="auth.register.name">Name</Trans>,
            type: "text",
            required: true,
            variant: "outlined",
            style: {marginBottom: "2.5rem"},
        },
        {
            name: "company",
            label: <Trans i18nKey="auth.register.company">Company</Trans>,
            type: "text",
            required: true,
            variant: "outlined",
            style: {marginBottom: "2.5rem"},
        },
        {
            name: "email",
            label: <Trans i18nKey="profile.email">E-Mail</Trans>,
            type: "email",
            required: true,
            variant: "outlined",
            style: {marginBottom: "2.5rem"},
        },
        {
            name: "password",
            label: <Trans i18nKey="profile.password">Password</Trans>,
            type: "password",
            required: true,
            variant: "outlined",
            style: {marginBottom: "2.5rem"},
        },
        {
            name: "password_confirmation",
            label: (
                <Trans i18nKey="profile.confirmPassword">
                    Confirm Password
                </Trans>
            ),
            type: "password",
            required: true,
            variant: "outlined",
            style: {marginBottom: "2.5rem"},
        },
        {
            name: "phone",
            label: <Trans i18nKey="auth.register.phone">Phone</Trans>,
            type: "phoneinput",
            required: true,
            variant: "outlined",
            style: {marginBottom: "2.5rem"},
        },
        {
            type: "address",
            required: true,
            variant: "outlined",
            style: {marginBottom: "2.5rem"},
        },
        {
            name: "city",
            label: <Trans i18nKey="auth.register.city">City</Trans>,
            type: "text",
            required: true,
            variant: "outlined",
            style: {marginBottom: "2.5rem", marginTop: "2.5rem"},
        },
        {
            name: "zip",
            label: <Trans i18nKey="auth.register.zip">Zip</Trans>,
            type: "text",
            required: true,
            variant: "outlined",
            style: {marginBottom: "2.5rem"},
        },
        {
            name: "country_id",
            label: <Trans i18nKey="profile.country">Country</Trans>,
            type: "select",
            required: true,
            variant: "outlined",
            style: {marginBottom: "2.5rem"},
            options: [],
        },
        {
            name: "vat_number",
            label: <Trans i18nKey="auth.register.vat_number">VAT number</Trans>,
            type: "text",
            required: true,
            variant: "outlined",
            style: {marginBottom: "2.5rem"},
        },
        {
            name: "shippingservice",
            label: <Trans i18nKey="auth.register.shippingservice">Shipping to repair courier</Trans>,
            type: "select",
            required: true,
            variant: "outlined",
            style: {marginBottom: "2.5rem"},
            options: [
                {
                    label: '',
                    key: "",
                    value: "",
                },
                {
                    label: <Trans i18nKey="auth.register.shippingservice.retailer">By retailer own transport</Trans>,
                    key: "retailer",
                    value: "retailer",
                },
                {
                    label: <Trans i18nKey="auth.register.shippingservice.b2x">By service center transport</Trans>,
                    key: "b2x",
                    value: "b2x",
                },
            ],
        },
        {
            name: "returnservice",
            label: <Trans i18nKey="auth.register.returnservice">Return to shop courier</Trans>,
            type: "select",
            required: true,
            variant: "outlined",
            style: {marginBottom: "2.5rem"},
            options: [
                {
                    label: '',
                    key: "",
                    value: "",
                },
                {
                    label: <Trans i18nKey="auth.register.returnservice.customer">By retailer own transport</Trans>,
                    key: "customer",
                    value: "customer",
                },
                {
                    label: <Trans i18nKey="auth.register.returnservice.rsp">By service center transport</Trans>,
                    key: "rsp",
                    value: "rsp",
                },
            ],
        },
        {
            name: "contractual_repair_days",
            label: <Trans i18nKey="auth.register.contractual_repair_days">Contractual Repair TAT / OTD</Trans>,
            type: "select",
            required: false,
            variant: "outlined",
            style: {marginBottom: "2.5rem"},
            options: [
                {
                    label: '',
                    key: "",
                    value: "",
                },
                {
                    label: <>1 <Trans i18nKey="common.day">day</Trans></>,
                    key: 1,
                    value: 1,
                },
                ...[...Array(29)].map((_, i) => {
                    return {
                        label: <>{i + 2} <Trans i18nKey="common.days">days</Trans></>,
                        key: i + 2,
                        value: i + 2,
                    };
                })
            ],
        },
    ],
};
